import _ from "lodash"
import $router from "../common/uni-router"
import { Volcengine } from "../common"
export default class WebVolcengine extends Volcengine {
  constructor(params) {
    if (!params) {
      params = {}
    }
    params.type = 1
    // 表示是web 端的SDK
    super(params)
    this.routerObject = null
    // web的vue-router 对象，默认为空
    this.isCustomPageviewOpen = false
    // 是否触发了PC端 custom_pageview_open 乾坤框架下，只能采取这样的方式上报 custom_pageview_open
    this.customPageviewOpenParam = null
    // PC端 custom_pageview_open 事件携带的参数
    this.afterEachRouter = null
    this.isPC = false

    try {
      // H5
      this.routerInfo = UNI_ROUTES.pages
      this.tarBar = UNI_ROUTES.tarBar ? UNI_ROUTES.tarBar.list : []
      const pages = this.getCurrentPagesArr()
      this.changeCurrentPage(pages)
    } catch (e) {
      // pc执行
      this.routerInfo = []
      this.tarBar = []
      if (params.routerObject) {
        const routerObject = params.routerObject
        const currentRouterObject = routerObject.history.current
        this.handelRouterObject(currentRouterObject)
        this.routerObject = routerObject
      }
      this.isPC = true
    }
  }

  start() {
    this.init(this.routerInfo, this.tarBar)
  }

  /**
   * 初始化滚动上报的相关参数
   */
  initScroll() {
    // y轴滚动条是否开始滚动
    this.scrollStart = false
    const scrollEventCache = this.getScrollEventCache()
    let scrollParam
    if (_.isEmpty(scrollEventCache) || !scrollEventCache.isInited) {
      scrollParam = {
        scrollTime: new Date().getTime(),
        scrollTop: 0,
        anchorList: [],
        isInited: true
      }
    }
    const param = {
      ...scrollEventCache,
      ...scrollParam
    }
    this.scrollTimeClear = null // 滚动事件的定时器
    this.setScrollEventCache(param)
  }

  /**
   * 监听路由的变化
   * @param {*} param 开发者自定义上报的参数
   * @returns
   */
  listenRouter(param) {
    if (this.isPC) {
      if (!this.routerObject) {
        return
      }
      this.routerObject.afterEach((to, from) => {
        if (this.isCustomPageviewOpen) {
          this.setCacheOldRouterTitle(document.title)
          this.afterGetWebPath(to)
          // 处理 custom_pageview_open 事件
        }
        const scrollEventCache = this.getScrollEventCache()
        if (!_.isEmpty(scrollEventCache) && scrollEventCache.isInited) {
          const that = this
          setTimeout(() => {
            that.reportScrollEvent()
            scrollEventCache.scrollTime = new Date().getTime()
            scrollEventCache.initAnchor = {}
            that.setScrollEventCache(scrollEventCache)
            that.scrollStart = false
            that.setAnchorList()
          }, 1000)
        }
        const routerInfo = {
          path: to.path,
          meta: to.meta,
          query: to.query,
          params: to.params
        }
        this.setCurrentRouterInfo(routerInfo)
        this.reportPageView(param, from, to)
        this.setCacheOldRouterTitle(document.title)
      })
    } else {
      const isEmptyObject = !_.isObject(param)
      if (isEmptyObject) {
        param = {}
      }
      $router.onchange = (now, old) => {
        this.reportPageView(param, old, now)
      }
    }
    // 监听页面隐藏事件 页面关闭的时候同样也会触发
    this.listenVisibilityChange(param)
  }

  /**
   * 监听滚动的变化
   * @param {*} param 开发者自定义上报的参数
   */
  listenScroll(param) {
    try {
      const isValid = this.checkScrollInitParams(param)
      if (!isValid) {
        return
      }
      this.initScroll()
      document.body.onscroll = () => {
        // 监听浏览器滚动事件( onscroll )
        // 事件触发的时候获取当前的scrollTop( this.scrollTop )，执行onScrollEnd函数(延迟500 )
        // 在执行onScrollEnd函数的时候再获取当前的scrollTop( nowScrollTop )
        // 拿当前的scrollTop与延时500毫秒之前的scrollTop进行比较，看是否相等，相等的话说明滚动条停止了滚动
        if (!this.scrollStart) {
          this.handleFirstSrcoll() // 滚动开始之前调用方法
          const extraParams = param.extraParams ? param.extraParams : {}
          this.reportScrollEvent(extraParams)
          const scrollCache = this.getScrollEventCache()
          scrollCache.scrollTime = 0 // 上报完成之后重置时间，下次记录的时间为：滚动结束之后
          scrollCache.anchorList = [] // 上报完成之后重置经过的锚点 下次记录的时间为：滚动结束之后
          this.setScrollEventCache(scrollCache)
        }
        if (this.scrollTimeClear) {
          clearTimeout(this.scrollTimeClear)
        }
        const scrollEventCache = this.getScrollEventCache()
        scrollEventCache.scrollTop = document.documentElement.scrollTop
        this.setScrollEventCache(scrollEventCache)
        this.scrollTimeClear = setTimeout(() => {
          this.onScrollEnd()
        }, 500)
      }
    } catch (e) {

    }
  }

  /**
   *
   * @param {*} param 自定义参数
   * @param {*} olderRouter 之前的旧路由
   * @param {*} nowRouter 当前路由
   * @returns
   */
  reportPageView(param, olderRouter, nowRouter) {
    try {
      const lastVisitUrl = this.getCacheVisitUrl()
      let nowPath = nowRouter.fullPath
      let oldPath = olderRouter.fullPath
      if (this.routerObject) {
        nowPath = nowRouter.path
        oldPath = olderRouter.path
      }
      if (lastVisitUrl === nowPath) {
        return
      }
      if (!this.volcengineProps[oldPath]) {
        this.updateRouter(this.routerInfo, this.tarBar)
      }
      const finalParam = this.getEventParam(param, oldPath, true, olderRouter)
      window.collectEvent("custom_pageview", finalParam)
      this.setCacheVisitUrl(nowPath)
      this.setCacheVisitWebUrl(window.location.href)
    } catch (e) {}
  }

  /**
   * 监听用户进入页面的事件
   * @param {*} param 用户自定义携带参数
   * @returns
   */
  customPageviewOpen(param) {
    if (this.routerObject) {
      this.customPageviewOpenParam = param
      this.isCustomPageviewOpen = true
      return
    }
    if (!_.isObject(param)) {
      param = {}
    }
    try {
      const currentUrl = this.getCurrentUrl() // 获取当前的页面路径
      const nowTime = new Date().getTime()
      this.setCacheTime(nowTime) // 重新记录页面停留时间
      this.setCacheVisitUrl(currentUrl)
      this.setCacheVisitWebUrl(window.location.href)
      if (!this.volcengineProps[currentUrl]) {
        this.updateRouter(this.routerInfo, this.tarBar)
      }
      const finalParam = this.getEventParam(param, currentUrl, false, {})
      window.collectEvent("custom_pageview_open", finalParam)
    } catch (e) {
    }
  }

  /**
   * 监听H5用户隐藏页面的事件 (PC端通过对 visibilityChange 事件的监听来实现)
   * @param {*} param 用户自定义携带参数
   * @returns
   */
  customPageviewHide(param) {
    if (this.routerObject) {
      return
    }
    if (!_.isObject(param)) {
      param = {}
    }
    // 如果是iOS的webview 则不触发
    try {
      const agent = window.navigator.userAgent
      const isIOS = agent.match(/(iphone os)/i) // iOS终端
      if (plus && isIOS) {
        return
      }
    } catch (e) {
    }
    try {
      const pages = this.getCurrentPagesArr()
      this.changeCurrentPage(pages)
      const currentUrl = this.getCurrentUrl()
      if (!this.volcengineProps[currentUrl]) {
        this.updateRouter(this.routerInfo, this.tarBar)
      }
      const commonAttr = this.getEventParam(param, currentUrl, false, {})
      window.collectEvent("custom_pageview_hide", commonAttr)
      // 上报当前页面的停留时间，然后onShow的时候会重新改写当前页面访问时间
      this.setCacheVisitUrl(currentUrl)
      this.setCacheVisitWebUrl(window.location.href)
      const pageviewParam = this.getEventParam(param, currentUrl, true, {})
      window.collectEvent("custom_pageview", pageviewParam)
    } catch (e) {
    }
  }

  afterGetWebPath(router) {
    try {
      const nowTime = new Date().getTime()
      this.setCacheTime(nowTime) // 重新记录页面停留时间
      this.setCacheVisitUrl(router.path)
      this.setCacheVisitWebUrl(window.location.href)
      const currentUrl = router.path
      const commonAttr = this.getEventParam(
        this.customPageviewOpenParam,
        currentUrl,
        false,
        router
      )
      window.collectEvent("custom_pageview_open", commonAttr)
      this.customPageviewOpenParam = null
      this.isCustomPageviewOpen = false
      const routerInfo = {
        path: router.path,
        meta: router.meta,
        query: router.query,
        params: router.params
      }
      this.setCurrentRouterInfo(routerInfo)
      const scrollEventCache = this.getScrollEventCache()
      if (!_.isEmpty(scrollEventCache)) {
        const that = this
        setTimeout(
          function() {
            that.recordScrollParam()
          }, 1000)
      }
    } catch (e) {}
  }

  afterReportEvent(reportEventName, reportEventParam) {
    try {
      const router = this.getCurrentRouterInfo()
      const meta = router.meta
      const title = meta ? meta.pageName || document.title : document.title
      const commonAttr = this.getEventParam(
        reportEventParam,
        router.path,
        false,
        router
      )
      commonAttr['custom_page_url'] = window.location.href
      commonAttr['custom_page_url_path'] = router.path
      if(!reportEventParam['custom_page_title']) {
        commonAttr['custom_page_title'] = reportEventName === 'sidebar_item_click'? this.getCacheOldRouterTitle():title
      }
      window.collectEvent(reportEventName, commonAttr)
    } catch (e) {}
  }

  // 设置用户Id

  setUserUniqueId(paramUserUniqueId) {
    const userUniqueId = paramUserUniqueId || this.nullProp
    try {
      window.collectEvent("config", {
        user_unique_id: userUniqueId
      })
    } catch (e) {}
  }
  collectApi(param) {
    const that = this
    setTimeout(() => {
      that.collectApiTask(param)
    }, 500)
  }
  // 接口请求上报
  collectApiTask(param) {
    try {
      const routeInfo = this.getCurrentRouterInfo()
      const meta = routeInfo.meta
      const title = meta ? meta.pageName || document.title : document.title
      const currentUrl = this.getCurrentUrl()
      this.setCacheVisitUrl(currentUrl)

      const apiRequestParam = {
        api_name: param.apiName,
        is_success: param.isSuccess,
        api_time_cost: param.apiTimeCost,
        custom_page_title: title,
        custom_page_url: window.location.href
      }

      const commonAttr = this.getEventParam(
        apiRequestParam,
        currentUrl,
        false,
        routeInfo
      )
      delete param.apiName
      delete param.isSuccess
      delete param.apiTimeCost

      const finalParam = {
        ...commonAttr,
        ...param
      }
      window.collectEvent("api_request", finalParam)
    } catch (e) {}
  }

  reportEvent(name, param) {
    if (this.routerObject) {
      this.afterReportEvent(name, param)
      return
    }
    const currentUrl = this.getCurrentUrl()
    this.setCacheVisitUrl(currentUrl)
    const finalParam = this.getEventParam(param, currentUrl, false, {})
    try {
      window.collectEvent(name, finalParam)
    } catch (e) {}
  }

  /**
   * 上报用户属性
   * @param {*} profileParam 用户属性组成的对象
   */
  profileSet(profileParam) {
    try {
      window.collectEvent("profileSet", profileParam)
    } catch (e) {}
  }

  sdkVersionProfileSet(param) {
    try {
      const sdkVersion = this.getSdkVersion()
      const finalParam = {
        ...param,
        ...sdkVersion
      }
      this.profileSet(finalParam)
    } catch (e) {}
  }

  appVersionProfileSet(param) {
    try {
      const appVersion = this.getAppVersion()
      const finalParam = {
        ...param,
        ...appVersion
      }
      this.profileSet(finalParam)
    } catch (e) {}
  }

  handelRouterObject(routerObject) {
    try {
      const route = routerObject.path
      const meta = routerObject.meta
      const path = route.substring(1, route.length)
      this.routerInfo = [
        {
          path,
          meta
        }
      ]
      this.changeCurrentPage([route])
    } catch (e) {}
  }
  /**
   * 滚动结束的时候触发
   */
  onScrollEnd() {
    const nowScrollTop = document.documentElement.scrollTop || document.body.scrollTop
    const scrollEventCache = this.getScrollEventCache()
    const isScrollEnd = nowScrollTop === scrollEventCache.scrollTop
    // 是否滚动结束了
    if (isScrollEnd) {
      this.recordScrollParam()
    }
  }

  listenVisibilityChange(param) {
    const that = this
    try {
      window.addEventListener("visibilitychange", (event) => {
        const isHidden = document.visibilityState === "hidden"
        if (that.routerObject) {
          if (isHidden) {
            const router = that.getCurrentRouterInfo()
            that.handlePageViewCloseByWeb(router, param)
            that.handlePageViewHideByWeb(router, param)
            that.handleReportScrollEvent()
          } else {
            const nowTime = new Date().getTime()
            this.setCacheTime(nowTime)
            // 重置滚动条停留时间
            this.resetScrollDurationTime(nowTime)
          }
        }
      })
    } catch (e) {}
  }

  // 上报滚动条页面停留事件
  handleReportScrollEvent() {
    const scrollEventCache = this.getScrollEventCache()
    if (!_.isEmpty(scrollEventCache)) {
      this.reportScrollEvent()
      this.scrollStart = false
    // 滚动没有开始，只是隐藏的时候上报停留事件
    }
  }

  // 重置滚动条的开始停留时间
  resetScrollDurationTime(nowTime) {
    const scrollEventCache = this.getScrollEventCache()
    if (!_.isEmpty(scrollEventCache)) {
      scrollEventCache.scrollTime = nowTime
      this.setScrollEventCache(scrollEventCache)
    }
  }

  handlePageViewCloseByWeb(router, param) {
    this.setCacheVisitUrl(router.path)
    this.setCacheVisitWebUrl(window.location.href)
    const commonAttr = this.getEventParam(param, router.path, true, router)
    window.collectEvent("custom_pageview", commonAttr)
  }

  handlePageViewHideByWeb(router, param) {
    const pageviewHideParam = this.getEventParam(
      param,
      router.path,
      false,
      router
    )
    window.collectEvent("custom_pageview_hide", pageviewHideParam)
  }

  recordScrollParam() {
    this.scrollStart = false // 此次滚动属于结束状态
    const scrollEventCache = this.getScrollEventCache()
    scrollEventCache.scrollTime = new Date().getTime()
    this.setScrollEventCache(scrollEventCache)
    this.setAnchorList()
  }

  setAnchorList() {
    const scrollEventCache = this.getScrollEventCache()
    const initAnchor = scrollEventCache.initAnchor || {}
    const isInitRecord = (!initAnchor || _.isEmpty(initAnchor))
    const initAnchorListData = {}
    const clientHeight = document.documentElement.clientHeight
    // 浏览器可视区域高度
    const clientWidth = document.documentElement.clientWidth
    // 浏览器可视区域宽度
    const nowScrollTop = document.documentElement.scrollTop || document.body.scrollTop
    const anchorWrapper = this.getElement(scrollEventCache.anchorWrapper)
    const anchorList = anchorWrapper.querySelectorAll("[id]")
    scrollEventCache.anchorList = []
    anchorList.forEach((item) => {
      // 获取元素相对于视口的位置
      const rect = item.getBoundingClientRect()
      if (isInitRecord) {
        initAnchorListData[item.getAttribute("id")] = {
          top: rect.top,
          bottom: rect.bottom
        }
      }
      const targetItem = isInitRecord ? rect : initAnchor[item.getAttribute("id")]
      if (targetItem) {
        // 是否满足上报条件
        const reportCondition = (rect.top < clientHeight && rect.bottom > 1 && rect.left < clientWidth && rect.right > 0)
        const distanceCondition = Math.abs(nowScrollTop - targetItem.top) <= scrollEventCache.scrollDistance || Math.abs(nowScrollTop - targetItem.bottom) <= scrollEventCache.scrollDistance
        if (reportCondition && distanceCondition) {
        // 滚动到两个锚点之间，超过这个距离就上报
          scrollEventCache.anchorList.push(item.getAttribute("id"))
        }
      }
    })
    if (isInitRecord) {
      scrollEventCache.initAnchor = initAnchorListData
    }
    this.setScrollEventCache(scrollEventCache)
  }

  reportScrollEvent(param) {
    this.scrollStart = true
    const scrollEventCache = this.getScrollEventCache()
    const duration = new Date().getTime() - scrollEventCache.scrollTime
    if (duration > scrollEventCache.scrollThreshold * 1000) {
      const scrollParam = this.getScrollParam(duration, param)
      window.collectEvent("scroll", scrollParam)
    }
  }

  getCurrentUrl() {
    if (this.routerObject) {
      const routeInfo = this.getCurrentRouterInfo()
      let path = routeInfo.path
      if (!routeInfo.path) {
        path = this.getNowPath(routeInfo)
      }
      return path
    }
    const pages = this.getCurrentPagesArr()
    this.changeCurrentPage(pages)
    let currentUrl = this.getCacheVisitUrl()
    if (this.pages.length > 0) {
      currentUrl = this.pages[0]
    } else {
      //  如果currentPage 为空数组，那就去循环路由数组，是否部分路由是包含于完整路由的
      const routerArr = this.routerInfo
      const nowFullPath = window.location.href
      routerArr.forEach((item) => {
        if (nowFullPath.indexOf(item.path) > -1) {
          currentUrl = "/" + item.path
        }
      })
    }
    // 如果没有任何匹配的，那就是首页
    if (!currentUrl) {
      currentUrl = "/" + this.routerInfo[0].path
    }
    return currentUrl
  }

  /**
   * 获取上报y轴滚动的参数
   */
  getScrollParam(duration, extraParams) {
    const scrollEventCache = this.getScrollEventCache()
    const anchorList = scrollEventCache.anchorList
    const anchorName = []
    if (anchorList && anchorList.length) {
      anchorList.map((item) => {
        const dom = document.getElementById(item)
        if (dom) {
          anchorName.push(dom.innerText)
        }
      })
    }
    const scrollParam = {
      custom_page_duration: duration, // 停留时长
      scrollTop: scrollEventCache.scrollTop, // y轴坐标
      anchorName: anchorName, // 经过的锚点
      ...extraParams
    }
    const router = this.getCurrentRouterInfo()
    const commonParam = this.getEventParam(scrollParam, router.path, false, router)
    return commonParam
  }

  /**
   * 获取所有事件需要上报的参数
   * @param {*} param 用户自定义参数
   * @param {*} path 页面路径
   * @param {*} isPageview 是否是要上报custom_pageview 事件
   * @param {*} router 页面路由 仅限PC 端
   * @returns
   */
  getEventParam(param, path, isPageview, router) {
    const commonAttr = this.getCommonAttr(path)
    let durationParam = {}
    if (isPageview) {
      const lastPageVisitTime = this.getCacheTime()
      const nowTime = new Date().getTime()
      durationParam = {
        custom_page_duration: nowTime - lastPageVisitTime
      }
      this.setCacheTime(nowTime)
    }
    if (router && router.meta) {
      commonAttr["custom_page_title"] = router.meta.pageName

      commonAttr["sub_app_name"] = router.meta.subAppName || this.nullProp
    }
    commonAttr["custom_page_url"] = this.getCacheVisitWebUrl()
    if (!commonAttr["custom_page_title"]) {
      const htmlTitle = this.getCacheOldRouterTitle()
      commonAttr["custom_page_title"] = htmlTitle
    }
    if (!commonAttr["custom_page_url_path"]) {
      commonAttr["custom_page_url_path"] = path
    }
    const versionInfo = this.getVersionInfo()
    const webRouterMeta = {}
    if (this.routerObject) {
      const webRouterMetaKeys = Object.keys(router.meta)
      webRouterMetaKeys.forEach((item) => {
        const volcengineFinalKey = item.replace(
          /[A-Z]/g,
          (key) => `_${key.toLowerCase()}`
        )
        webRouterMeta[volcengineFinalKey] = router.meta[item]
      })
    }
    const oldFullUrlPath = this.getCacheVisitWebUrl()
    const sourceObject = this.getFromQueryNameContent(oldFullUrlPath)
    const eventParams = {
      ...commonAttr,
      ...durationParam,
      ...versionInfo,
      ...sourceObject,
      ...webRouterMeta,
      ...param
    }
    try {
      let plusCacheParam = {
        ...commonAttr,
        ...versionInfo,
        ...sourceObject,
        ...webRouterMeta
      }
      if (isPageview) {
        plusCacheParam = {
          ...plusCacheParam,
          ...param
        }
      }
      this.setWebviewCache(plusCacheParam)
    } catch (e) {
    }
    return eventParams
  }

  /**
   * 判断监听滚动的初始化参数是否符合要求
   * @param {*} initParam  初始化参数
   * @returns bool
   */
  checkScrollInitParams(initParam) {
    let isValid = true
    if (!this.isPC) {
      isValid = false
      console.warn("监听滚动失败，非PC端")
    }
    const anchorWrapper = this.getElement(initParam.anchorWrapper)
    if (!anchorWrapper) {
      isValid = false
      console.warn("监听滚动失败，非HTMLElement")
    }
    const orginThreshold = initParam.threshold || 0
    const threshold = typeof orginThreshold === "string" ? parseFloat(orginThreshold) : orginThreshold
    if (!_.isFinite(threshold)) {
      isValid = false
      console.warn("监听滚动失败，秒数参数非Number类型")
    }
    const originDistance = initParam.distance || 400
    const scrollDistance = typeof originDistance === "string" ? parseFloat(originDistance) : originDistance
    if (!_.isFinite(scrollDistance)) {
      isValid = false
      console.warn("监听滚动失败，滚动阈值参数非Number类型")
    }
    const extraParams = initParam.extraParams || {}
    if (!_.isObject(extraParams)) {
      isValid = false
      console.warn("监听滚动失败，额外参数非Object类型")
    }
    if (isValid) {
      const scrollEventCache = this.getScrollEventCache()
      scrollEventCache.scrollDistance = scrollDistance
      scrollEventCache.anchorWrapper = initParam.anchorWrapper
      scrollEventCache.scrollThreshold = threshold
      this.setScrollEventCache(scrollEventCache)
    }
    return isValid
  }
  /**
   * 获取dom 元素
   * @param {*} el dom 元素 或 css 选择器
   * @returns dom 元素
   */
  getElement(el) {
    if (el === "") {
      return document.body // 如果什么都不传的话，就是默认为body
    }
    const element = typeof el === "string" ? document.querySelector(el) : el
    return _.isElement(element) ? element : false
  }

  handleFirstSrcoll() {
    const scrollEventCache = this.getScrollEventCache()
    if (!scrollEventCache.initAnchor || _.isEmpty(scrollEventCache.initAnchor)) {
      this.recordScrollParam()
    }
  }
}
